import axios from 'axios';
import { BASE_URL } from '../constants/api-urls';
import { getAuth0AuthHeaders } from './auth0Session';

export type VerifyPasswordResult =
  | { success: true }
  | { success: false; message: string };

const CURRENT_PASSWORD_ERROR = 'Current password is incorrect';

/**
 * Verifies the current user's password via POST /auth0/verify-password.
 * Requires an active session (Bearer token) and matching userId.
 */
export const verifyAuth0Password = async (
  userId: string,
  password: string,
  email?: string
): Promise<VerifyPasswordResult> => {
  const normalizedUserId = userId?.trim();
  const normalizedEmail = email?.trim()?.toLowerCase();

  if (!normalizedUserId || !password) {
    return { success: false, message: 'Current password is required' };
  }

  const headers = getAuth0AuthHeaders();
  if (!headers.Authorization) {
    return {
      success: false,
      message: 'Your session has expired. Please log out and log in again.',
    };
  }

  try {
    const response = await axios.post(
      `${BASE_URL}/auth0/verify-password`,
      {
        userId: normalizedUserId,
        password,
        ...(normalizedEmail ? { email: normalizedEmail } : {}),
      },
      { headers }
    );

    if (response.data?.success) {
      return { success: true };
    }

    return {
      success: false,
      message: response.data?.message || CURRENT_PASSWORD_ERROR,
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || CURRENT_PASSWORD_ERROR,
      };
    }

    return { success: false, message: CURRENT_PASSWORD_ERROR };
  }
};
